<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Utilisateurs</span>
        <h3 class="page-title">Liste des utilisateurs</h3>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Recherche</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3 col-sm-4">
                <div class="form-group">
                  <input
                    v-model.trim="model.firstName"
                    id="firstName"
                    name="firstName"
                    type="text"
                    autofocus
                    placeholder="Prénom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3 col-sm-4">
                <div class="form-group">
                  <input
                    v-model.trim="model.lastName"
                    id="lastName"
                    name="lastName"
                    type="text"
                    placeholder="Nom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3 col-sm-4">
                <div class="form-group">
                  <input
                    v-model.trim="model.email"
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3 col-sm-4">
                <div class="form-group">
                  <sorted-select
                    :model="model"
                    name="permissions.groupReference"
                    firstOption="Groupes"
                    :listOptions="groups"
                    value="reference"
                    title="name"
                  ></sorted-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 col-sm-4">
                <div class="form-group">
                  <sorted-select
                    :model="model"
                    name="structureReference"
                    firstOption="Structures"
                    :listOptions="structuresList"
                    value="reference"
                    title="name"
                  ></sorted-select>
                </div>
              </div>
              <div class="col-md-3 col-sm-4">
                <div class="form-group">
                  <button class="btn btn-outline-info mr-2" @click="resetForm">
                    Reset
                  </button>
                  <button class="btn btn-success" @click="fetchUsers">
                    Recherche
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Table</h6>
          </div>
          <div class="card-body p-0">
            <div
              v-if="!accountingMode && !loading && isAccounting()"
              class="mt-4 pl-4 pb-2 pr-4"
            >
              <button class="btn btn-primary btn-java mr-2" @click="modeCompta">
                {{ $t("user.list.accounting.mode") }}
              </button>
            </div>
            <div v-if="accountingMode && !loading" class="mt-4 pl-4 pb-2 pr-4">
              <button
                v-if="isAdministrator()"
                class="btn btn-primary btn-java mr-2"
                @click="modeAdmin"
              >
                {{ $t("user.list.admin.mode") }}
              </button>
              <button
                v-d-toggle.my-collapse
                class="btn btn-primary btn-royal-blue"
              >
                {{ $t("user.list.accounting.actions") }}
              </button>
              <d-collapse id="my-collapse">
                <div class="p-3 mt-3 border rounded">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="d-flex justify-content-between w-75 mb-4">
                        <p class="mb-0">
                          {{ $t("user.list.accounting.apply.selection") }}
                        </p>
                        <d-checkbox
                          class="ml-auto my-auto"
                          @change="
                            (value) => (this.appliedToAll = value !== true)
                          "
                          :checked="!appliedToAll"
                          toggle
                        />
                      </div>
                      <div class="d-flex justify-content-between w-75 mb-4">
                        <p class="mb-0">
                          {{ $t("user.list.accounting.apply.all") }}
                        </p>
                        <d-checkbox
                          class="ml-auto my-auto"
                          @change="
                            (value) => (this.appliedToAll = value === true)
                          "
                          :checked="appliedToAll"
                          toggle
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div
                        class="d-flex justify-content-between mb-4 align-items-baseline"
                      >
                        <p></p>
                        <div
                          aria-label="Button group"
                          class="btn-group-undefined btn-group"
                        >
                          <button
                            class="btn btn-success btn-danger"
                            @click="openModalConge()"
                          >
                            <i class="fa fa-calendar-plus mr-2"></i>
                            {{ $t("user.list.accounting.update.solde") }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="d-flex" style="justify-content: flex-end">
                        <button
                          class="btn btn-outline-secondary mr-4"
                          @click="() => (this.selectedUsers = [])"
                        >
                          {{ $t("global.unselect.all") }}
                        </button>
                        <button class="btn btn-primary" @click="selectAll">
                          {{ $t("global.select.all") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </d-collapse>
            </div>
            <spinner-dot v-if="loading" />
            <data-table
              v-else
              :data="gridData"
              :fields="gridColumnsTitle"
              :selectedFields="selectedFields"
              :fieldsGrid="gridColumnsFields"
              :tableState="state"
              :count="count"
            >
            </data-table>
          </div>
        </div>
      </div>
    </div>
    <solde-conge ref="congeModal" @updateLeftVacations="updateLeftVacations" />
    <history-update-modal ref="historyModal" />
  </div>
</template>

<script>
/* eslint-disable */
import {
  checkIfCanEditUser,
  isAccounting,
  isAdministrator,
} from "../../utils/Rules.js";
import groups from "@/data/groups/Groups";
import DataTable from "../../components/dataTable/dataTable";
import userGrid from "@/data/dataTable/userGrid.json";
import DataUtils from "../../utils/DataUtils";
import ObjectUtil from "../../utils/ObjectUtil";
import TimeUtils from "../../utils/TimeUtils";
import SortedSelect from "../../components/form/SortedSelect";
import GroupsHelper from "../../helper/GroupsHelper";
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import SoldeConge from "../../components/user/daysOff/soldeConge";
import HistoryUpdateModal from "../../components/user/daysOff/historyUpdateModal";

export default {
  components: {
    HistoryUpdateModal,
    SoldeConge,
    SpinnerDot,
    SortedSelect,
    DataTable,
  },

  mounted() {
    this.pendingPopulate();
  },

  data() {
    return {
      listUsers: [],
      count: 0,
      include: [],
      groups: groups,
      // all values available for the table
      gridColumnsFields: userGrid.grid,
      gridColumnsTitle: userGrid.grid.map((grid) => {
        return grid.title;
      }),
      loading: true,
      gridFill: {},
      accountingMode: false,
      appliedToAll: false,
      selectedUsers: [],
      selectedFields: [],
      userSelectedFields: [
        "ID",
        "Structure",
        "Groupes",
        "Responsables",
        "Nom",
        "Prénom",
        "Date de création",
        "Voir",
        "Editer",
      ],
      accountingSelectedFields: [
        "Selection",
        "Structure",
        "Groupes",
        "Nom",
        "Prénom",
        "Solde",
        "Historique",
        "Date de création",
      ],
      accountingGridFill: {
        Structure: (user) => {
          let structure = this.structuresList.find(
            (structure) => structure.reference === user.structureReference
          );
          return {
            component: "html-td",
            content: structure ? structure.name : "N/A",
            key: this.structuresList.length,
          };
        },
        Selection: (user) => {
          return {
            component: "checkbox-td",
            action: this.updateSelection,
            id: user.reference,
            selection: this.selectedUsers,
          };
        },
        Groupes: (user) => {
          return {
            component: "html-td",
            content: GroupsHelper.userGroup(user.permissions, "mb-1"),
            key: user.permissions.length,
          };
        },
        Solde: (user) => {
          return (user.information.leftPaidVacations || "0") + " jours";
        },
        Historique: (user) => {
          return {
            component: "button-td",
            class: "btn-light",
            icon: "fa fa-history",
            action: this.openHistoryModal,
            id: user.information.leftPaidVacationsHistory,
          };
        },
      },
      userGridFill: {
        ID: (user) => {
          return {
            component: "link-td",
            content: user.reference,
            href: "/profile/" + user.reference,
          };
        },
        Mail: (user) => {
          return {
            component: "link-td",
            content: user.email,
            href: "mailto:" + user.email,
          };
        },
        Groupes: (user) => {
          return {
            component: "html-td",
            content: GroupsHelper.userGroup(user.permissions, "mb-1"),
            key: user.permissions.length,
          };
        },
        Structure: (user) => {
          let structure = this.structuresList.find(
            (structure) => structure.reference === user.structureReference
          );
          return {
            component: "html-td",
            content: structure ? structure.name : "N/A",
            key: this.structuresList.length,
          };
        },
        Editer: (user) => {
          return {
            component: "button-td",
            class: "btn-success",
            disabled: !checkIfCanEditUser(this.user, user),
            icon: "fa fa-edit",
            action: this.editUser,
            id: user.reference,
          };
        },
        Voir: (user) => {
          return {
            component: "button-td",
            class: "btn-light",
            icon: "fa fa-eye",
            action: this.showProfile,
            id: user.reference,
          };
        },
      },
    };
  },
  computed: {
    state() {
      return this.$store.state.user.listTableState;
    },
    structuresList() {
      return this.$store.state.structure.list;
    },
    user() {
      return this.$store.state.user.informations;
    },
    userIsAccounting: {
      get: function () {
        return this.$store.state.user.informations.accounting;
      },
      set: function (value) {
        this.$store.commit("setUserAccounting", value);
      },
    },
    model: {
      get: function () {
        return this.$store.state.user.listFormModel;
      },
      set: function (model) {
        this.$store.commit("setListUserModel", model);
      },
    },
    gridData() {
      return this.listUsers.map((user) => {
        let res = {};
        this.include.forEach((field) => {
          if (this.gridFill[field.title]) {
            res[field.title] = this.gridFill[field.title](user);
          } else if (field.title.includes("Date")) {
            res[field.title] = TimeUtils.formatDate(user[field.value]);
          } else {
            res[field.title] = DataUtils.formatString(
              ObjectUtil.deepFind(user, field.value)
            );
          }
        });
        return res;
      });
    },
  },

  watch: {
    state: {
      handler: function () {
        this.fetchUsers();
      },
      deep: true,
    },
  },
  methods: {
    openModalConge() {
      this.$refs.congeModal.openModal(this.appliedToAll);
    },
    openHistoryModal(list) {
      this.$refs.historyModal.openModal(list);
    },
    modeAdmin() {
      this.loading = true;
      this.gridFill = this.userGridFill;
      this.selectedFields = this.userSelectedFields;
      this.accountingMode = false;
      this.loading = false;
      this.fetchUsers();
    },
    modeCompta() {
      this.loading = true;
      this.selectedUsers = [];
      this.gridFill = this.accountingGridFill;
      this.selectedFields = this.accountingSelectedFields;
      this.accountingMode = true;
      this.loading = false;
      this.fetchUsers();
    },
    selectAll() {
      this.selectedUsers = [];
      this.listUsers.forEach((user) => {
        this.selectedUsers.push(user.reference);
      });
    },
    updateSelection(reference) {
      let index = this.selectedUsers.indexOf(reference);
      if (index >= 0) {
        this.selectedUsers.splice(index, 1);
      } else {
        this.selectedUsers.push(reference);
      }
    },
    updateLeftVacations({ days, mode }) {
      if (!this.appliedToAll && this.selectedUsers.length === 0) {
        this.$miniToastr.error(this.$t("user.list.actions.error"));
      } else {
        this.loading = true;
        this.$services.user
          .updateLeftVacations({
            appliedToAll: this.appliedToAll,
            selectedUsers: this.selectedUsers,
            days,
            mode,
          })
          .then(() => {
            this.$miniToastr.success(this.$t("user.edit.success"));
            this.selectedUsers = [];
            this.appliedToAll = false;
            this.fetchUsers();
          })
          .catch(() => (this.loading = false));
      }
    },
    isAdministrator() {
      return isAdministrator(this.user);
    },
    isAccounting() {
      return isAccounting(this.user);
    },
    pendingPopulate() {
      // We're waiting a bit that the store is populate in case of refresh
      if (!this.user.reference && !this.user.token) {
        setTimeout(() => {
          this.pendingPopulate();
        }, 350);
      } else {
        this.load();
      }
    },
    load() {
      if (isAccounting(this.user)) {
        this.userIsAccounting = true;
      }
      if (this.userIsAccounting) {
        this.gridFill = this.accountingGridFill;
        this.selectedFields = this.accountingSelectedFields;
        this.accountingMode = true;
      } else {
        this.gridFill = this.userGridFill;
        this.selectedFields = this.userSelectedFields;
      }
      this.loading = false;
      if (this.gridData.length === 0) {
        this.fetchUsers();
      }
    },
    showProfile(reference) {
      this.$router.push(`/profile/${reference}`);
    },
    editUser(reference) {
      this.$router.push(`/edit-utilisateur/${reference}`);
    },
    fetchUsers() {
      this.loading = true;
      this.selectedUsers = [];
      this.appliedToAll = false;
      this.include = this.gridColumnsFields.filter((obj) => {
        if (this.selectedFields.indexOf(obj.title) >= 0) return true;
      });
      this.include.push({ title: "Responsables", value: "inCharge" });
      this.$services.user
        .findFromModel(
          this.model,
          this.include,
          this.state.page,
          this.state.perPage,
          this.state.field,
          this.state.ascending,
          this.gridColumnsFields
        )
        .then((res) => {
          this.loading = false;
          this.count = res.data.count;
          this.listUsers = res.data.data;
        });
    },
    resetForm() {
      this.model = {};
      this.$store.commit("resetListTableState");
      this.fetchUsers();
    },
  },
};
</script>
